/**
 * Shared helper functions for Knockout template bindings.
 * Exposed on window.Helpers by site.ts for use in .cshtml KO templates.
 */

import type { ITeam } from './interfaces/ITeam';

/** Convert a dictionary to an array of {key, value} pairs for KO foreach bindings. */
export function mapDictionaryToArray<T>(dict: Record<string, T>): { key: string; value: T }[] {
  if (!dict) return [];
  return Object.entries(dict).map(([key, value]) => ({ key, value }));
}

/** Sort {key, value} team pairs by ConferenceRank. Handles both KO observables and plain objects. */
export function rankSort(a: any, b: any): number {
  const aVal = a.value ? (typeof a.value === 'function' ? a.value().ConferenceRank() : a.value.ConferenceRank?.()) : 0;
  const bVal = b.value ? (typeof b.value === 'function' ? b.value().ConferenceRank() : b.value.ConferenceRank?.()) : 0;
  return aVal - bVal;
}

/** Sort {key, value} team pairs by DivisionRank (NHL-specific). */
export function divisionRankSort(a: any, b: any): number {
  const aVal = a.value ? (typeof a.value === 'function' ? a.value().DivisionRank() : a.value.DivisionRank?.()) : 0;
  const bVal = b.value ? (typeof b.value === 'function' ? b.value().DivisionRank() : b.value.DivisionRank?.()) : 0;
  return aVal - bVal;
}
